import React from 'react';
import { IAdminStudyDto } from '../../../services/api/api-client';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { expandRowButtonColumn } from 'uikit/table/columns/ExpandRowButtonColumn';
import TableCommonStyles from 'uikit/table/appTableCommonStyles.module.scss';
import { BulletPoints } from 'uikit/BulletPoints';

export const useStudyColumns = (): ColumnDef<IAdminStudyDto>[] => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'id',
      header: t('StudiesList.Columns.Id'),
      cell: ({ row }) => row.original.id.toString().padStart(3, '0'),
      size: 20,
      meta: {
        centered: true,
        top: true,
      },
    },
    {
      accessorKey: 'studyNumber',
      header: t('StudiesList.Columns.Number'),
      enableSorting: false,
      size: 20,
      meta: {
        isColored: true,
        centered: true,
        top: true,
      },
    },
    {
      accessorKey: 'title',
      header: t('StudiesList.Columns.Title'),
      enableSorting: false,
      meta: {
        dontUseHeaderWidth: true,
        top: true,
      },
    },
    {
      accessorKey: 'isEcrf',
      header: '',
      enableSorting: false,
      size: 110,
      cell: ({ row }) => <span>{row.original.hasEcrf ? 'eCRF' : ''}</span>,
      meta: {
        isColored: true,
        top: true,
      },
    },
    {
      accessorKey: 'duration',
      header: t('StudiesList.Columns.Duration'),
      enableSorting: false,
      size: 110,
      meta: {
        headerClassName: TableCommonStyles.wrap,
        centered: true,
        top: true,
      },
    },
    {
      id: 'groups',
      header: t('StudiesList.Columns.Groups'),
      size: 280,
      cell: ({ row }) => <BulletPoints values={row.original.groups.map((x) => x.title)} />,
      meta: {
        top: true,
        isColored: true,
      },
    },
    {
      accessorKey: 'isTokenActive',
      header: 'Is Token Active',
      size: 20,
      meta: {
        centered: true,
        top: true,
      },
    },
    expandRowButtonColumn({}),
  ];
};
